import React from 'react';

const TemplateCreateForm = ({
  newTemplateName,
  setNewTemplateName,
  newTemplateType,
  setNewTemplateType,
  creating,
  createTemplate,
  closeCreateForm,
}) => (
  <div className="create-form">
    <h3><span>➕</span> Utwórz nowy szablon</h3>

    <div className="form-group">
      <label className="form-label">Nazwa szablonu:</label>
      <input
        type="text"
        className="form-input"
        value={newTemplateName}
        onChange={(e) => setNewTemplateName(e.target.value)}
        placeholder="np. Mój własny szablon faktury"
        autoFocus
      />
    </div>

    <div className="form-group">
      <label className="form-label">Typ dokumentu:</label>
      <select
        className="form-input"
        value={newTemplateType}
        onChange={(e) => setNewTemplateType(e.target.value)}
        style={{ padding: '8px 12px' }}
      >
        <option value="invoice">Faktura</option>
        <option value="correction">Faktura korygująca</option>
        <option value="receipt">Paragon</option>
      </select>
      <small style={{ color: 'var(--text-secondary)', fontSize: '11px', marginTop: '4px', display: 'block' }}>
        Szablon będzie automatycznie używany dla wybranego typu dokumentu
      </small>
    </div>

    <div className="form-actions">
      <button
        onClick={createTemplate}
        disabled={creating || !newTemplateName.trim()}
        className="btn btn-success"
      >
        {creating ? (
          <>
            <span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }}></span>
            Tworzenie...
          </>
        ) : (
          <>
            <span>✅</span> Utwórz szablon
          </>
        )}
      </button>
      <button
        onClick={closeCreateForm}
        className="btn btn-secondary"
      >
        <span>❌</span> Anuluj
      </button>
    </div>
  </div>
);

const TemplateCard = ({
  template,
  editingTemplateName,
  setEditingTemplateName,
  renameTemplate,
  editTemplate,
  previewTemplateHandler,
  previewLoading,
  duplicateTemplate,
  duplicatingTemplate,
  toggleTemplateAnchor,
  deleteTemplate,
}) => (
  <div className="template-card">
    <div className="template-card-info">
      <div className="template-card-header">
        {editingTemplateName === template.id ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="text"
              className="form-input"
              defaultValue={template.name}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  renameTemplate(template.id, e.target.value);
                } else if (e.key === 'Escape') {
                  setEditingTemplateName(null);
                }
              }}
              onBlur={(e) => renameTemplate(template.id, e.target.value)}
              autoFocus
              style={{ maxWidth: '250px' }}
            />
            <button
              onClick={() => setEditingTemplateName(null)}
              className="btn btn-secondary btn-sm"
            >
              ❌
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <h4 className="template-card-title">
              {template.anchored && <span>🔒</span>}
              <span>📄</span> {template.name}
            </h4>
            <button
              onClick={() => setEditingTemplateName(template.id)}
              className="btn btn-icon"
              style={{ background: 'transparent', padding: '4px' }}
              title="Zmień nazwę"
            >
              ✏️
            </button>
          </div>
        )}
        <span className="template-badge template-badge-id">
          ID: {template.id}
        </span>
        {template.anchored && (
          <span className="template-badge template-badge-anchored">
            🔒 Zakotwiczony
          </span>
        )}
        <span className="template-badge" style={{
          backgroundColor: template.template_type === 'correction' ? 'var(--warning-light)' :
                           template.template_type === 'receipt' ? 'var(--info-light)' : 'var(--success-light)',
          color: template.template_type === 'correction' ? 'var(--warning)' :
                 template.template_type === 'receipt' ? 'var(--info)' : 'var(--success)'
        }}>
          {template.template_type === 'correction' ? '📝 Korekta' :
           template.template_type === 'receipt' ? '🧾 Paragon' : '📄 Faktura'}
        </span>
      </div>
      <div className="template-card-meta">
        <span>📅 Utworzono: {template.created_at ? new Date(template.created_at).toLocaleString('pl-PL') : 'N/A'}</span>
        {template.description && (
          <span>📝 {template.description}</span>
        )}
      </div>
    </div>

    <div className="template-card-actions">
      <button
        onClick={() => editTemplate(template)}
        className="btn btn-primary btn-sm"
      >
        <span>✏️</span> Edytuj
      </button>
      <button
        onClick={() => previewTemplateHandler(template)}
        disabled={previewLoading}
        className="btn btn-secondary btn-sm"
        style={{ opacity: previewLoading ? 0.6 : 1 }}
      >
        {previewLoading ? '⏳' : '👁️'} Podgląd
      </button>
      <button
        onClick={() => duplicateTemplate(template)}
        disabled={duplicatingTemplate === template.id}
        className="btn btn-success btn-sm"
        style={{ opacity: duplicatingTemplate === template.id ? 0.6 : 1 }}
        title="Duplikuj szablon"
      >
        {duplicatingTemplate === template.id ? '⏳' : '📋'} Kopia
      </button>
      <button
        onClick={() => toggleTemplateAnchor(template.id, template.anchored)}
        className={`btn btn-sm ${template.anchored ? 'btn-outline' : 'btn-secondary'}`}
        title={template.anchored ? "Odkotwicz szablon" : "Zakotwicz szablon"}
      >
        {template.anchored ? '🔓 Odkotwicz' : '🔒 Kotwica'}
      </button>
      <button
        onClick={() => deleteTemplate(template.id, template.name, template.anchored)}
        disabled={template.anchored}
        className="btn btn-danger btn-sm"
        style={{ opacity: template.anchored ? 0.5 : 1 }}
        title={template.anchored ? "Szablon jest zakotwiczony" : "Usuń szablon"}
      >
        🗑️ Usuń
      </button>
    </div>
  </div>
);

const TemplateList = ({
  templates,
  loading,
  editingTemplateName,
  setEditingTemplateName,
  renameTemplate,
  editTemplate,
  previewTemplateHandler,
  previewLoading,
  duplicateTemplate,
  duplicatingTemplate,
  toggleTemplateAnchor,
  deleteTemplate,
}) => (
  <div className="templates-section">
    <h3>
      <span>📋</span> Lista szablonów
      <span className="templates-count">{templates.length}</span>
    </h3>

    {templates.length === 0 && !loading ? (
      <div className="empty-state">
        <div className="empty-state-icon">📭</div>
        <h4>Brak szablonów</h4>
        <p>Kliknij "Nowy szablon" aby utworzyć pierwszy szablon.</p>
      </div>
    ) : (
      <div className="templates-grid">
        {templates.map(template => (
          <TemplateCard
            key={template.id}
            template={template}
            editingTemplateName={editingTemplateName}
            setEditingTemplateName={setEditingTemplateName}
            renameTemplate={renameTemplate}
            editTemplate={editTemplate}
            previewTemplateHandler={previewTemplateHandler}
            previewLoading={previewLoading}
            duplicateTemplate={duplicateTemplate}
            duplicatingTemplate={duplicatingTemplate}
            toggleTemplateAnchor={toggleTemplateAnchor}
            deleteTemplate={deleteTemplate}
          />
        ))}
      </div>
    )}
  </div>
);

const TemplateInfoPanel = () => (
  <div className="preview-section" style={{ marginTop: '30px' }}>
    <h4 style={{ margin: '0 0 15px 0', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '10px' }}>
      <span>ℹ️</span> Informacje o kreatorze szablonów
    </h4>
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px'
    }}>
      <div style={{
        padding: '15px',
        background: 'var(--success-light)',
        borderRadius: '8px',
        borderLeft: '4px solid var(--success)'
      }}>
        <strong style={{ color: 'var(--success)' }}>✅ Dostępne funkcje</strong>
        <ul style={{ margin: '10px 0 0', paddingLeft: '18px', color: 'var(--success)', fontSize: '13px' }}>
          <li>Tworzenie nowych szablonów</li>
          <li>Edycja pól i treści</li>
          <li>Podgląd PDF</li>
          <li>Duplikowanie szablonów</li>
          <li>Kotwiczenie szablonów</li>
        </ul>
      </div>
      <div style={{
        padding: '15px',
        background: 'var(--warning-light)',
        borderRadius: '8px',
        borderLeft: '4px solid var(--warning)'
      }}>
        <strong style={{ color: 'var(--warning)' }}>💡 Wskazówki</strong>
        <ul style={{ margin: '10px 0 0', paddingLeft: '18px', color: 'var(--warning)', fontSize: '13px' }}>
          <li>Kliknij "Edytuj" aby modyfikować pola</li>
          <li>Używaj zmiennych {'{nazwa}'} dla danych dynamicznych</li>
          <li>Kotwica chroni szablon przed usunięciem</li>
        </ul>
      </div>
    </div>
  </div>
);

export { TemplateCreateForm, TemplateList, TemplateInfoPanel };
export default TemplateList;
